"use client";

import { ScrollRevealText } from "@/components/ui/scroll-reveal-text";
import { md, useMediaMinWidthBeforePaint } from "@/hooks/use-media-min-width";

interface HomeHeroTitleProps {
  /** Mobile + desktop lead — Figma 4074:23618 appends a period on mobile only. */
  lead: string;
  /** Desktop-only second line (Figma 6032:27581). */
  subtitle: string;
}

/**
 * Homepage hero headline — mobile shows lead only; desktop adds subtitle on
 * a second line. All copy uses solid grey-950 (Figma 6032:27581).
 *
 * A single ScrollRevealText holds the copy so the H1 text is in the DOM once
 * (crawlers and extractors used to read it four times). Server and first
 * client render agree on the desktop copy; the before-paint media hook swaps
 * the children to the mobile copy with no hydration mismatch, and
 * ScrollRevealText re-measures when its text changes.
 */
export function HomeHeroTitle({ lead, subtitle }: HomeHeroTitleProps) {
  const isDesktop = useMediaMinWidthBeforePaint(md);
  const mobileLead = lead.endsWith(".") ? lead : `${lead}.`;

  return (
    <ScrollRevealText variant="light" className="text-balance">
      {isDesktop ? (
        <>
          {lead}
          <br />
          {subtitle}
        </>
      ) : (
        mobileLead
      )}
    </ScrollRevealText>
  );
}
